import React from 'react';

const LumivetaLogo = ({ size = 'default', showText = true, className = '' }) => {
  const sizes = {
    small: { icon: 24, text: 'text-lg' },
    default: { icon: 32, text: 'text-xl' },
    large: { icon: 48, text: 'text-3xl' },
  };

  const { icon, text } = sizes[size] || sizes.default;

  return (
    <div className={`flex items-center gap-2 ${className}`}>
      {/* Lantern Icon */}
      <div className="relative">
        <svg 
          width={icon} 
          height={icon * 1.2} 
          viewBox="0 0 32 40" 
          className="lantern-glow"
        >
          {/* Lantern hook */}
          <path d="M 16 0 L 16 6" stroke="#DAA520" strokeWidth="2" fill="none" />
          {/* Top cap */}
          <rect x="11" y="6" width="10" height="3" fill="#DAA520" rx="1" />
          {/* Body frame */}
          <rect x="9" y="9" width="14" height="22" fill="none" stroke="#FFD700" strokeWidth="1.5" rx="2" />
          {/* Inner glass with glow */}
          <rect x="11" y="11" width="10" height="18" fill="rgba(255, 215, 0, 0.2)" rx="1" />
          {/* Flame */}
          <ellipse cx="16" cy="20" rx="3" ry="5" fill="#FFD700" opacity="0.9" />
          <ellipse cx="16" cy="19" rx="2" ry="3" fill="#FFE55C" />
          {/* Bottom cap */}
          <rect x="11" y="31" width="10" height="3" fill="#DAA520" rx="1" />
        </svg>
      </div>

      {showText && (
        <span className={`font-heading font-bold text-gold-gradient ${text}`}>
          Lumiveta
        </span>
      )}
    </div>
  );
};

export default LumivetaLogo;
